"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var ui_1 = require("@aperza/ui");
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var util_1 = require("@aperza/util");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var SellerShippingTooltip = /** @class */ (function (_super) {
    __extends(SellerShippingTooltip, _super);
    function SellerShippingTooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SellerShippingTooltip.prototype.render = function () {
        function SellerShippingTooltipWeight(props) {
            if (props.shippingInfo.additionalShippingFeesWeight &&
                props.shippingInfo.additionalShippingFeesWeight.length > 0) {
                return (react_1.default.createElement("span", null,
                    react_1.default.createElement("span", { className: "col-tooltips", style: { float: 'right', marginLeft: '10px' }, "data-tip": JSON.stringify(props.shippingInfo.additionalShippingFeesWeight), "data-for": 'additionalWeight_' + props.shippingInfo.locationCode }, react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faWeightHanging })),
                    react_1.default.createElement(react_tooltip_1.default, { id: 'additionalWeight_' + props.shippingInfo.locationCode, className: "cell-tooltip", place: "right", type: "info", getContent: function (weights) {
                            var parsedWeights = JSON.parse(weights);
                            if (parsedWeights) {
                                return parsedWeights.map(function (weight, index) {
                                    return (react_1.default.createElement("div", { key: 'w_' + index, className: "list-item-tooltip" },
                                        react_1.default.createElement("ul", null,
                                            react_1.default.createElement("li", null,
                                                react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.referenceWeight" }),
                                                " :",
                                                ' ',
                                                weight.referenceWeight),
                                            react_1.default.createElement("li", null,
                                                react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.shippingFeePerAdditionalKilo" }),
                                                ":",
                                                ' ',
                                                util_1.CurrencyUtil.parseCurrency(weight.shippingFeePerAdditionalKilo)),
                                            react_1.default.createElement("li", null,
                                                react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.shippingFee" }),
                                                " :",
                                                ' ',
                                                weight.shippingFee != 0 ? (util_1.CurrencyUtil.parseCurrency(weight.shippingFee, true)) : (react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.free" }))))));
                                });
                            }
                        } })));
            }
            else {
                return null;
            }
        }
        function SellerShippingTooltipQuantity(props) {
            if (props.shippingInfo.additionalShippingFeesQuantity &&
                props.shippingInfo.additionalShippingFeesQuantity.length > 0) {
                return (react_1.default.createElement("span", null,
                    react_1.default.createElement("span", { className: "col-tooltips", style: { float: 'right', marginLeft: '10px' }, "data-tip": JSON.stringify(props.shippingInfo.additionalShippingFeesQuantity), "data-for": 'additionalQuantity_' + props.shippingInfo.locationCode }, react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faShoppingBag })),
                    react_1.default.createElement(react_tooltip_1.default, { id: 'additionalQuantity_' + props.shippingInfo.locationCode, className: "cell-tooltip", place: "right", type: "info", getContent: function (quantities) {
                            var parsedQuantities = JSON.parse(quantities);
                            if (parsedQuantities) {
                                return parsedQuantities.map(function (quantity, index) {
                                    return (react_1.default.createElement("div", { key: 'q_' + index, className: "list-item-tooltip" },
                                        react_1.default.createElement("ul", null,
                                            react_1.default.createElement("li", null,
                                                react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.shippingFeePerAdditionalQuantity" }),
                                                ' ',
                                                ":",
                                                ' ',
                                                util_1.CurrencyUtil.parseCurrency(quantity.shippingFeePerAdditionalQuantity)),
                                            react_1.default.createElement("li", null,
                                                react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.shippingFee" }),
                                                " :",
                                                ' ',
                                                quantity.shippingFee != 0 ? (util_1.CurrencyUtil.parseCurrency(quantity.shippingFee, true)) : (react_1.default.createElement(ui_1.Message, { messageId: "seller.shippingFee.free" }))))));
                                });
                            }
                        } })));
            }
            else {
                return null;
            }
        }
        return this.props.shippingType == 'weight' ? (react_1.default.createElement(SellerShippingTooltipWeight, __assign({}, this.props))) : (react_1.default.createElement(SellerShippingTooltipQuantity, __assign({}, this.props)));
    };
    SellerShippingTooltip.propTypes = {
        shippingInfo: prop_types_1.default.object.isRequired,
        shippingType: prop_types_1.default.string.isRequired,
    };
    return SellerShippingTooltip;
}(react_1.default.Component));
exports.default = SellerShippingTooltip;
